module.exports = __webpack_public_path__ + "img/MyPCP-Enrollment-Slider-2.8dfb670a.svg";